import { ActionContext } from 'vuex';
import { ListStateItem, ListModuleItem } from '@/store/shared/index'
import DeclareCustoms from './entity'
import Invoice from './invoice'
import Packing from './boxing'
import { $http } from '@/lib'
import { PageResult } from '@/store/shared/entity';
import { DeclarationElementDto, DeclarationElementProductDto } from './productelement'
import ProductElement from './productelement'
import Detail from './detail'
import CopyProductElement from './copyproductelement';
import BillOfLading from "@/store/modules/shipment/declarecustoms/billoflading";
import ImportGoodsDetail from "@/store/modules/shipment/declarecustoms/importgoodsdetail";

//定义 interface  常用情况 edit页面entity  codelist等   页面需要的数据对象都要在此声明
interface DeclareCustomsState extends ListStateItem<DeclareCustoms> {
    editDeclareCustoms: DeclareCustoms;
    invoiceData: Invoice;
    packingData: Packing;
    declareCustomsList: DeclareCustoms;
    editProductElement: ProductElement;
    editElement: DeclarationElementProductDto;
    detailData: Detail;
    copyProductElement: CopyProductElement;
    billOfLading: BillOfLading;
    importGoodsDetail: ImportGoodsDetail;
    getBillOfLadingLoading: boolean;
}
class DeclareCustomsModule extends ListModuleItem<DeclareCustomsState, any, DeclareCustoms>{

    //构造函数 （必须）将派生类中 的overrideState 和 overrideMutations 与基类（ListModuleItem）中的state mutations合并
    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    //state  页面需要的数据对象都要在此实例化  
    overrideState = {
        editDeclareCustoms: new DeclareCustoms(),
        declareCustomsList: new DeclareCustoms(),
        editElement: new DeclarationElementProductDto(),
        editProductElement: new ProductElement(),
        copyProductElement: new CopyProductElement(),
        billOfLading: new BillOfLading(),
        importGoodsDetail: new ImportGoodsDetail(),
        getBillOfLadingLoading: false
    }

    //action中 function 都是异步
    actions = {

        //分页查询
        async getAll(context: ActionContext<DeclareCustomsState, any>, payload: any) {
        
            context.state.table.loading = true;
            let reponse = await $http.get('/services/app/DeclareCustoms/GetAll', { params: payload.data });
            context.state.table.loading = false;
            let page = reponse.data.result as PageResult<DeclareCustoms>;
            context.state.table.totalCount = page.totalCount;
            context.state.table.list = page.items;

        },

        //新增
        async create(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/Create', payload.data);
            return response.data.result as DeclareCustoms;
        },
        //更新
        async update(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            await $http.put('services/app/DeclareCustoms/Update', payload.data);
        },
        //删除
        async delete(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            await $http.delete('/services/app/DeclareCustoms/Delete?Id=' + payload.data.id);
        },
        //根据id获取单个记录
        async get(context: ActionContext<DeclareCustomsState, any>, payload: any) {

            let reponse = await $http.get('/services/app/DeclareCustoms/Get?Id=' + payload.id);
            context.state.editDeclareCustoms = reponse.data.result;
            return reponse.data.result as DeclareCustoms;
        },
        //获取发票单
        async getInvoice(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareCustoms/GetInvoice?Id=' + payload.id);
            context.state.invoiceData = reponse.data.result;
            return reponse.data.result as Invoice;
        },
        //下载发票单
        async exportInvoiceForm(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/ExportInvoiceForm', payload.data, { responseType: "blob" });
            return response;
        },
        //获取装箱单
        async getPacking(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareCustoms/GetPacking?Id=' + payload.id);
            context.state.packingData = reponse.data.result;
            return reponse.data.result as Invoice;
        },
        //下载装箱单
        async exportPackingForm(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/ExportPackingForm', payload.data, { responseType: "blob" });
            return response;
        },
        //获取报关单
        async getDeclareCustomsList(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareCustoms/GetDeclareCustomsList?Id=' + payload.id);
            context.state.declareCustomsList = reponse.data.result;
            return reponse.data.result as DeclareCustoms;
        },
        //更新报关单
        async updateDeclareCustomsList(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            await $http.put('services/app/DeclareCustoms/UpdateDeclareCustomsList', payload.data);
        },
        //下载报关单
        async exportCustomsForm(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/ExportCustomsForm', payload.data, { responseType: "blob" });
            return response;
        },
        //获取申报要素
        async getDeclarationElementProductList(context: ActionContext<DeclareCustomsState, any>, payload: any) {

            let reponse = await $http.get('/services/app/DeclareCustoms/GetDeclarationElementProduct?Id=' + payload.id);
            context.state.editProductElement = reponse.data.result;
            return reponse.data.result as ProductElement;
        },
        //更新申报要素
        async updateDeclarationElementProductList(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            await $http.put('services/app/DeclareCustoms/UpdateDeclarationElementProduct', payload.data);
        },
            //提交申报要素
            async updateDeclarationElementProductSubmitList(context: ActionContext<DeclareCustomsState, any>, payload: any) {
                await $http.put('services/app/DeclareCustoms/UpdateDeclarationElementProductSubmit', payload.data);
            },
        //下载申报要素
        async exportDeclarationElementForm(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/ExportDeclarationElementForm', payload.data, { responseType: "blob" });
            return response;
        },
        //报表下载
        async exportAllForm(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/ExportAllForm', payload.data, { responseType: "blob" });
            return response;
        },
        //检查是否能批量下载
        async checkdownloadDeclareProduct(context: ActionContext<DeclareCustomsState, any>, payload: any) {
 
            let reponse = await $http.get('/services/app/DeclareCustoms/GetCheckdownloadDeclareProduct?Id=' + payload.id);

            return reponse.data.result as DeclareCustoms;
        },
        //检查是否能批量下载
        async checkdownloadElement(context: ActionContext<DeclareCustomsState, any>, payload: any) {
         
            let reponse = await $http.get('/services/app/DeclareCustoms/GetCheckdownloadElement?Id=' + payload.id);

            return reponse.data.result as DeclareCustoms;
        },
        //查看
        async getData(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareCustoms/GetData?Id=' + payload.id);
            context.state.detailData = reponse.data.result;
            return reponse.data.result as Invoice;
        },
          //获取客户对应的付款方式
          async getPayment(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareCustoms/GetPayment?Id=' + payload.id);
            return reponse.data.result as string;
        },
        // 导出
        async exportShipmentDetails(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/ExportShipmentDetails', {id: payload.data.id}, { responseType: "blob" });
            return response;
        },
        //获取客户对应的付款方式
        async getDeclarationElementProductByShippingNumber(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let reponse = await $http.get('/services/app/DeclareCustoms/GetDeclarationElementProductByShippingNumber', { params: payload });
            return reponse.data.result as string;
        },
        // 复制申报要素
        async copyDeclarationElementProduct(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/CopyDeclarationElementProduct', {
                origin: payload.data.declarationElementProductDtoList,
                target: payload.data.target
            });
            return context.state.editProductElement.declarationElementProductDtoList = response.data.result as Array<DeclarationElementProductDto>;
        },
        // 复制申报要素
        async copyDeclarationElementProductItem(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/CopyDeclarationElementProductItem', {
                origin: payload.data.declarationElementProductDto,
                index: payload.data.index,
                target: context.state.editProductElement.declarationElementProductDtoList
            });
            return context.state.editProductElement.declarationElementProductDtoList = response.data.result as Array<DeclarationElementProductDto>;
        },
        // 提单上传
        async billOfLadingUpload(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            await $http.post('services/app/DeclareCustoms/BillOfLadingUpload', payload.data);
        },
        // 获取提单文件
        async getBillOfLading(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            context.state.getBillOfLadingLoading = true;
            let response = await $http.get('services/app/DeclareCustoms/GetBillOfLading', {params: {id: context.state.billOfLading.id}}).finally(() => {
                context.state.getBillOfLadingLoading = false;
            });
            return response.data.result.fileList;
        },
        // 导入出口货物明细单
        async importExportGoodsDetail(context: ActionContext<DeclareCustomsState, any>, payload: any) {
            let response = await $http.post('services/app/DeclareCustoms/ImportExportGoodsDetail', payload.data);
            return response.data.result;
        },
        // 下载出口货物明细单模板
        async downloadImportGoodsDetailTemplate(context: ActionContext<DeclareCustomsState, any>) {
            let response = await $http.post('services/app/DeclareCustoms/DownloadImportGoodsDetailTemplate', null, { responseType: "blob" });
            return response;
        },
    };

    overrideMutations = {

        edit(state: DeclareCustomsState, declareCustoms: DeclareCustoms) {

            state.editDeclareCustoms = declareCustoms;
        },

        editProductElement(state: DeclareCustomsState, declarationElementProductDto: DeclarationElementProductDto) {
           
        
            state.editElement = declarationElementProductDto;


        },
        editSaveProductElement(state: DeclareCustomsState, declarationElementProductDto: DeclarationElementProductDto) {

            let index = state.editProductElement.declarationElementProductDtoList.findIndex(e => e.itemIndexNumber == declarationElementProductDto.itemIndexNumber);
            if (index === -1) {
                return;
            }
            state.editProductElement.declarationElementProductDtoList.splice(index, 1, declarationElementProductDto);
        },
        setCopyProductElement(state: DeclareCustomsState, copyProductElement: CopyProductElement) {
            state.copyProductElement = copyProductElement;
        },
        openBillOfLading(state: DeclareCustomsState, id: number) {
            state.billOfLading = new BillOfLading();
            state.billOfLading.id = id;
        },
        openImportGoodsDetail(state: DeclareCustomsState) {
            state.importGoodsDetail = new ImportGoodsDetail();
        },


    }
}

const declareCustomsModule = new DeclareCustomsModule();
export default declareCustomsModule;


